import {
  ServiceFormSchema,
  TenantFormSchema,
  PersonFormSchema,
  RoleFormSchema,
  MemberFormSchema,
  TransactionServiceFormSchema,
  TransactionAddonFormSchema,
  TransactionFormSchema,
  ItemFormSchema,
  WaiverFormSchema,
  TransactionWaiverFormSchema,
  SubscriptionFormSchema,
  // DEFAULT IMPORT ADD
} from "./form.rule";

export const loginFormDefault = {
  username: "",
  password: "",
};
export const serviceFormDefault = {
  name: "",
  description: "",
  amount: 0,
  duration: 0,
  isOpenTime: false,
  upgrade: 0,
  isActive: true,
  isSubscription: true,
  days: 0,
  tenant: "",
} as ServiceFormSchema;
export const tenantFormDefault = {
  owner: "",
  businessName: "",
  businessType: "",
  description: "",
  avatar: "",
  email: "",
  mobileNumber: "",
  phone: "",
  website: "",
  membershipDate: "" as any,
  rewardsType: "",
} as TenantFormSchema;
export const personFormDefault = {
  tenant: "",
  role: "",
  firstName: "",
  middleName: "",
  lastName: "",
  username: "",
  email: "",
  password: "",
  isVerified: false,
  avatar: "",
  gender: "",
  birthday: "" as any,
  isBlocked: false,
  mobileNumber: "",
  fatherName: "",
  motherName: "",
  emergencyContact_1Number: "",
  emergencyContact_1Name: "",
  emergencyContact_1Relationship: "",
  emergencyContact_2Number: "",
  emergencyContact_2Name: "",
  emergencyContact_2Relationship: "",
  sss: "",
  philhealth: "",
  pagibig: "",
  tin: "",
  medicalCondition: "",
  bloodType: "",
  elementary: "",
  highSchool: "",
  college: "",
  postCollege: "",
  undergraduate: "",
  curriculumVitae: "",
  supportingDoc: "",
  intentLetter: "",
  applicationLetter: "",
  address: "",
  photo: undefined,
} as PersonFormSchema;
export const roleFormDefault = {
  name: "",
  description: "",
} as RoleFormSchema;
export const memberFormDefault = {
  tenant: "",
  parentCode: "",
  firstName: "",
  middleName: "",
  lastName: "",
  email: "",
  gender: "",
  birthday: "",
  mobileNumber: "",
  avatar: "",
  emergencyContact_1Number: "",
  emergencyContact_1Name: "",
  emergencyContact_1Relationship: "",
  emergencyContact_2Number: "",
  emergencyContact_2Name: "",
  emergencyContact_2Relationship: "",
  streetName: "",
  subdivision: "",
  zone: "",
  sitio: "",
  purok: "",
  barangay: "",
  municipality: "",
  province: "",
  region: "",
  country: "",
  zip: "",
  longitude: 0,
  latitude: 0,
  isChild: false,
  isGuardian: false,
  photo: undefined,
  age: 0,
} as MemberFormSchema;
export const transactionServiceFormDefault = {
  batch: "",
  member: "",
  service: "",
  date: "",
  time: "",
  amount: 0,
  serviceData: null,
} as TransactionServiceFormSchema;
export const transactionAddonFormDefault = {
  batch: "",
  item: "",
  quantity: 0,
  amount: 0,
  itemData: undefined,
} as TransactionAddonFormSchema;
export const transactionFormDefault = {
  service: [],
  addon: [],
  isPaid: false,
} as TransactionFormSchema;
export const itemFormDefault = {
  name: "",
  description: "",
  amount: 0,
  tenant: "",
  duration: 0,
} as ItemFormSchema;
export const waiverFormDefault = {
  tenant: "",
  name: "",
  description: "",
  fontSize: 0,
  subTitle: "",
  waiverMeta: null,
} as WaiverFormSchema;
export const transactionWaiverFormDefault = {
  batch: "",
  waiver: "",
  signature: "",
  file: "",
} as TransactionWaiverFormSchema;
export const subscriptionFormDefault = {
  tenant: "",
  member: "",
  service: "",
  startDate: "",
  endDate: "",
  amount: 0,
  isSubscription: false,
} as SubscriptionFormSchema;
// DEFAULT ADD
